import { jsx as _jsx } from "react/jsx-runtime";
import { IconButton, Tooltip } from '@dixa/lib-shared-habla';
import { useCallback } from 'react';
import { appActions } from 'app/app.actions';
import { analytics } from 'app/utils/segment';
import { useAppDispatch } from 'utils/redux/useAppDispatch';
import { useConversationRow } from '../../../../../utils/useConversationRow';
/**
 * Represents the component for displaying the preview button in the
 * conversations table row.
 */
export const ConversationsTablePreviewButton = () => {
    const dispatch = useAppDispatch();
    const { conversationAndRequester: { conversation }, } = useConversationRow();
    /** Handles previewing the conversation. */
    const handleClick = useCallback(() => {
        dispatch(appActions.showModal({
            modal: {
                type: 'app:conversationPreview',
                arg: { csid: conversation.id },
            },
        }));
        analytics.conversationsItemPreviewClicked();
    }, [conversation, dispatch]);
    return (_jsx(Tooltip, Object.assign({ content: "Preview this conversation", side: "left", dark: true }, { children: _jsx(IconButton, { icon: "eye", variant: "tertiary", onClick: handleClick }) })));
};
